export enum DesignInvoiceState {
    ReadyToGenerate = "ReadyToGenerate",
    EditsRequired = "EditsRequired",
    Sent = "Sent",
    Paid = "Paid",
}
